import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
// import {toastr} from 'react-redux-toastr'
import axios from 'axios';


async function getApi(data) {
    const apiUrl = API.baseURL + `/providers/web_in_conversation`;
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* inConversationData(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        yield put({ type: 'GET_IN_CONVERSATION_DATA_SUCCESS', data: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_IN_CONVERSATION_DATA_FAILED', message: e.message });
    }
}

function* inConversationSaga() {
    yield takeEvery('GET_IN_CONVERSATION_DATA_REQUESTED', inConversationData);
}

export default inConversationSaga;